import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './config.model';

const CONFIG_STORAGE_KEY = 'app_config';
const CONFIG_VERSION_KEY = 'app_config_version';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig;

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    const cachedConfig = localStorage.getItem(CONFIG_STORAGE_KEY);
    const cachedVersion = localStorage.getItem(CONFIG_VERSION_KEY);

    // pobieramy config z serwera (lekki request)
    const freshConfig = await this.http
      .get<AppConfig>(`assets/config/config.json?v=${Date.now()}`)
      .toPromise();

    if (cachedConfig && cachedVersion === freshConfig?.version) {
      this.config = JSON.parse(cachedConfig);
      return;
    }

    this.config = freshConfig!;

    localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(this.config));
    localStorage.setItem(CONFIG_VERSION_KEY, this.config.version);
  }

  refresh(): Promise<void> {
    localStorage.removeItem(CONFIG_STORAGE_KEY);
    localStorage.removeItem(CONFIG_VERSION_KEY);

    return this.load();
  }

  get apiBaseUrl(): string {
    return this.config?.apiBaseUrl ?? '';
  }

  get eldoradoApiBaseUrl(): string {
    return this.config?.eldoradoApiBaseUrl ?? '';
  }

  get b2bApiBaseUrl(): string {
    return this.config?.b2bApiBaseUrl ?? '';
  }

  getCountries() {
    return this.config?.countries ?? [];
  }

  getPaymentMethods() {
    return this.config?.paymentMethods ?? [];
  }

  getTransportMethods() {
    return this.config?.transportMethods ?? [];
  }

  private getTodayKey(): string {
    const now = new Date();

    return [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, '0'),
      String(now.getDate()).padStart(2, '0'),
    ].join('-');
  }
}
